import React from 'react';
import { HolidaySettings } from '../../HolidaySettings';
import { LabelSettings } from '../../LabelSettings';

interface AdditionalSectionProps {
  isActive: boolean;
  showHolidays: boolean;
  onToggleHolidays: (value: boolean) => void;
  onShowMessage: (type: 'success' | 'error' | 'info', text: string) => void;
}

export const AdditionalSection: React.FC<AdditionalSectionProps> = ({
  isActive,
  showHolidays,
  onToggleHolidays,
  onShowMessage
}) => {
  return (
    <section className={isActive ? 'space-y-3' : 'hidden'}>
      <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4">
        <HolidaySettings showHolidays={showHolidays} onToggleHolidays={onToggleHolidays} />
      </div>

      <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4">
        <LabelSettings
          onUpdate={() => {
            onShowMessage('info', 'Label definitions updated. Refresh the dashboard to see changes.');
          }}
        />
      </div>
    </section>
  );
};
